<template>
  <!-- @contextmenu="changeTarget($event)" -->
  <div style="overflow: hidden">
    <model-viewer
      style="width: 100%; height: 100vh; min-height: 100vh"
      :src="getImgUrl()"
      :ios-src="getIosUrl()"
      auto-rotate
      camera-controls
      ar
      ar-modes="webxr scene-viewer quick-look"
      ar-scale="auto"
      alt="A 3D model of an astronaut"
      id="vv"
    ></model-viewer>
  </div>
</template>
<script>
//Vue.component("htmlImport", htmlImport);
import store from "../store";

import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer.js";

export default {
  name: "viewerAR",
  data: function () {
    return {
      sourc: "",
    };
  },
  methods: {
    getImgUrl() {
      //console.log(store.state.viewerPath);
      return store.state.viewerPath;
    },
    getIosUrl() {
      return store.state.viewerIosPath;
    },
    changeTarget(e) {
      console.log(e.pageX), console.log(e.pageY);

      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("vv");
      console.log(modelViewer.getBoundingClientRect());

      let left = e.pageX;
      let top = e.pageY;

      modelViewer.style.transform = "translate(-50%, -50%)";

      modelViewer.style.left = left + "px";
      modelViewer.style.top = top + "px";

      //var g = +screen.height - 400 + "px";
      //modelViewer.style.transform = "translate(0, " + g + ")";

      /*
      let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (e.target == modelViewer) {
        e.target.style.top = e.target.offsetTop - pos2 + "px";
        e.target.style.left = e.target.offsetLeft - pos1 + "px";
      }
      */

      e.preventDefault();
    },
  },
};
</script>